import React, { Component } from 'react';
import { Form, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import {
  Container,
  PrimaryButtonV2,
  formLayout,
  formValidateMessages,
  FormWrapper,
  SpaceBetween,
  SecondaryButton,
  AddFormItemLabel,
  AddSaveHint,
} from 'utils';
import RichText from './RichText';
import { ProjectsActions } from 'redux/actions';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

const FormItem = Form.Item;

class ProjectDescription extends Component {
  formRef = React.createRef();

  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
  };

  state = {
    initialValues: {
      projekt: '',
      zielgruppe: '',
      unterstützen: '',
      finanzierung: '',
      hinter: '',
    },
  };

  onFinish = (values) => {
    const {
      updateDraft,
      projectId,
      currentStep,
      setCanMove,
      showModal,
      selectedStep,
      setSubmitFromModal,
      editProject,
    } = this.props;
    const { projekt, zielgruppe, unterstützen, finanzierung, hinter } = values;
    const projectDescription = {
      faq: [projekt, zielgruppe, unterstützen, finanzierung, hinter],
    };

    if (showModal) {
      updateDraft(projectId, projectDescription, selectedStep - 1);
      setSubmitFromModal(false);
    } else {
      updateDraft(projectId, projectDescription, currentStep);
    }

    setCanMove(true);
    if (editProject) this.props.handleSteps(4);
    else this.props.handleSteps(6);
  };

  getContent = (content, name) => {
    this.formRef.current.setFieldsValue({ [name]: content });
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else this.props.handleSteps(4);
  };

  render() {
    const { project, loading, setCanMove, projectId, editProject } = this.props;
    return (
      <Container className="inside-form-container">
        <Spin spinning={loading}>
          <h1>Zusätzliche Angaben</h1>
          <p style={{ fontSize: '18px ' }}>
            Hier sind einige Fragen, die besonders häufig von Unterstützern
            gestellt werden.
          </p>
          <p style={{ fontWeight: '600', color: '#3F621A' }}>
            Unsere Erfahrung: Je mehr Informationen, desto mehr Unterstützung!
          </p>
          {!loading && (
            <Form
              ref={this.formRef}
              {...formLayout}
              name="project-details"
              onFinish={this.onFinish}
              onChange={() => setCanMove(false)}
              validateMessages={formValidateMessages}
              initialValues={
                projectId
                  ? project
                    ? pickBy(project.projectDescription, identity)
                    : {}
                  : ''
              }
            >
              <div>
                <FormWrapper>
                  <>
                    <FormItem
                      name={'projekt'}
                      label={
                        <AddFormItemLabel>
                          Was ist der genaue Zweck des Projektes?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            'Bitte geben Sie den Zweck des Projektes ein.',
                        },
                      ]}
                    >
                      <RichText
                        name="projekt"
                        getContent={this.getContent}
                        placeholder="Antwort eingeben..."
                      />
                    </FormItem>
                    <FormItem
                      name={'zielgruppe'}
                      label={
                        <AddFormItemLabel>
                          Was sind die Ziele und wer ist die Zielgruppe?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            'Bitte geben Sie die Ziele und Zielgruppe ein.',
                        },
                      ]}
                    >
                      <RichText
                        name="zielgruppe"
                        getContent={this.getContent}
                        placeholder="Antwort eingeben..."
                      />
                    </FormItem>
                    <FormItem
                      name={'unterstützen'}
                      label={
                        <AddFormItemLabel>
                          Warum sollte die Community dein Projekt unterstützen?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            'Bitte geben Sie die Einordnung/Relevanz ein.',
                        },
                      ]}
                    >
                      <RichText
                        name="unterstützen"
                        getContent={this.getContent}
                        placeholder="Antwort eingeben..."
                      />
                    </FormItem>
                    <FormItem
                      name={'finanzierung'}
                      label={
                        <AddFormItemLabel>
                          Wofür wird das Geld benötigt?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            'Bitte geben Sie an, wofür das Geld benötigt wird.',
                        },
                      ]}
                    >
                      <RichText
                        name="finanzierung"
                        getContent={this.getContent}
                        placeholder="Antwort eingeben..."
                      />
                    </FormItem>
                    <FormItem
                      name={'hinter'}
                      label={
                        <AddFormItemLabel>
                          Wer ist alles in deinem Projekt involviert?
                        </AddFormItemLabel>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message:
                            'Bitte geben Sie die Macher des Projektes ein.',
                        },
                      ]}
                      validateTrigger="onBlur"
                    >
                      <RichText
                        name="hinter"
                        getContent={this.getContent}
                        placeholder="Stelle dich vor, damit die Community weiß, wen sie unterstützt."
                      />
                    </FormItem>
                  </>
                </FormWrapper>
              </div>

              {editProject && <AddSaveHint />}

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.onReturn}
                  >
                    {editProject ? (
                      <p>Zurück zur Projektübersicht</p>
                    ) : (
                      <>
                        <ArrowLeftOutlined />
                        <p>Zurück</p>
                      </>
                    )}
                  </SecondaryButton>

                  <PrimaryButtonV2
                    type="primary"
                    htmltype="submit"
                    minWidth="120px"
                    id="submit-button"
                  >
                    {editProject ? (
                      <p>Speichern*</p>
                    ) : (
                      <>
                        <p>Weiter</p>
                        <ArrowRightOutlined />
                      </>
                    )}
                  </PrimaryButtonV2>
                </SpaceBetween>
              </FormItem>
            </Form>
          )}
        </Spin>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;
  return {
    project,
    loading,
    errors,
    currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDescription);
